import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CalendarModule } from "primeng/calendar";

import { ServiceTermsComponent } from './serviceTerms/serviceTerms.component';
import { RequestFormComponent } from './requestForm/requestForm.component';
import { AppComponent } from './solicitud-tarjeta.component';
import { MakeAppointmentComponent } from './makeAppointment/makeAppointment.component';

import { RecaptchaModule } from 'angular-google-recaptcha';

declare var recaptchaKey: string;

@NgModule({
	declarations: [
		AppComponent,
		ServiceTermsComponent,
		RequestFormComponent,
		MakeAppointmentComponent
	],
	imports: [
		BrowserModule,
		HttpModule,
		BrowserAnimationsModule,
		FormsModule,
		CalendarModule,
		RecaptchaModule.forRoot({
            siteKey: recaptchaKey,
        })
	],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/solicitud-tarjeta.module.ts